<script setup lang="ts">
import { usePlayerFlagsStore } from '@/stores/playerFlagsStore.ts'
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import Alert from '@/components/Elements/Alerts/Alert.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { handleNext } from '../tutorialSteps'
const playerFlagsStore = usePlayerFlagsStore()
const route = useRoute()
const router = useRouter()

const handleNextStep = async () => {
  await handleNext('tutorial_technology_tree')
}

const isOnResearchSection = computed(() => {
  return route.path.startsWith('/research')
})

const goToResearch = () => {
  router.push('/research')
}

</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/science.webm"
  >
    <template #text>
      <p class="pb-2">
        Welcome to the Technology Tree! This is where you can see all available technologies and their relationships.
      </p>
      <p class="pb-2">
        The tree shows how technologies connect - some require others to be researched first. Lines with arrows show these dependencies.
      </p>
      <p class="pb-2">
        Technologies marked as <span class="text-blue-500">blue</span> is what you are currently working on, <span class="text-yellow-500">yellow</span> are dependencies for your target and will be researched first. Finally <span class="text-green-500">green</span> is your current research target.
      </p>
    </template>

    <template #alerts>
      <Alert type="info" class="hidden md:flex">
        Try clicking the right/left mouse button while dragging the technology tree around and zooming with your mouse wheel to explore it.
      </Alert>
      <Alert type="info" class="md:hidden">
        Try scrolling around by swiping on your mobile screen.
      </Alert>
    </template>

    <template #buttons>
      <ActionButton v-if="!isOnResearchSection" @click="goToResearch" class="mr-2">
        Go to Research
      </ActionButton>
      <ActionButton @click="handleNextStep">
        That worked, how do i pick what to research?
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss"></style>